/*eslint-disable*/
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import FastAPIClient from "../../src/client";
import config from "../../src/config";

// Initialize FastAPI client
const client = new FastAPIClient(config);

const RouteLogger = () => {
    const location = useLocation();

    useEffect(() => {
        // Get browser and device info
        const { browser, version } = getBrowserInfo();
        const device = getDeviceType();

        // Send session data to the server
        if (navigator.onLine) {
            client.createUserSession(location.pathname, browser, device);
        } else {
            console.log("User is offline, skipping session API call.");
        }
    }, [location]);

    return null; // This component does not render anything
};

// Function to detect browser name and version
const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browser = "Unknown";
    let version = "Unknown";

    if (/firefox|fxios/i.test(userAgent)) {
        browser = "Firefox";
        version = userAgent.match(/firefox\/([\d.]+)/i)?.[1] || "Unknown";
    } else if (/edg/i.test(userAgent)) {
        browser = "Edge";
        version = userAgent.match(/edg\/([\d.]+)/i)?.[1] || "Unknown";
    } else if (/opr|opera/i.test(userAgent)) {
        browser = "Opera";
        version = userAgent.match(/(opera|opr)\/([\d.]+)/i)?.[2] || "Unknown";
    } else if (/chrome|chromium/i.test(userAgent) && !/edg/i.test(userAgent)) {
        browser = "Chrome";
        version = userAgent.match(/chrome\/([\d.]+)/i)?.[1] || "Unknown";
    } else if (/safari/i.test(userAgent) && !/chrome/i.test(userAgent)) {
        browser = "Safari";
        version = userAgent.match(/version\/([\d.]+)/i)?.[1] || "Unknown";
    }

    return { browser, version };
};

// Function to detect device type accurately
const getDeviceType = () => {
    return window.innerWidth <= 768 ? "Mobile" : "Desktop";
};

export default RouteLogger;
